import type { LandingFeature } from '../content/landingFeatures';
import { PhoneMockup } from './PhoneMockup';

type FeatureSectionProps = {
  feature: LandingFeature;
  reverse?: boolean;
  isLast?: boolean;
};

export function FeatureSection({ feature, reverse = false, isLast = false }: FeatureSectionProps) {
  return (
    <section
      id={feature.id}
      aria-labelledby={`${feature.id}-title`}
      className={`landing-snap-panel px-4 sm:px-6 md:py-24 ${isLast ? 'landing-snap-panel-last' : ''}`}
    >
      <div
        className={`mx-auto flex w-full max-w-6xl flex-1 min-h-0 flex-col gap-10 max-md:gap-12 md:items-center md:gap-14 lg:gap-20 ${
          isLast ? 'max-md:pb-12' : 'max-md:pb-8'
        } ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'}`}
      >
        <div className="shrink-0 pt-2 max-md:px-1 max-md:text-center md:flex-1 md:pt-3 md:text-left">
          <h2
            id={`${feature.id}-title`}
            className="font-display text-2xl leading-[1.2] sm:text-4xl md:text-5xl font-medium tracking-tight text-[#111818] mb-2 sm:mb-4 md:mb-5 max-md:max-w-[17rem] max-md:mx-auto"
          >
            {feature.title}
          </h2>
          <p className="text-sm sm:text-lg text-[#638888] leading-relaxed max-w-lg mx-auto md:mx-0 max-md:max-w-[18rem]">
            {feature.description}
          </p>
        </div>
        <div className="flex flex-1 min-h-0 w-full items-end justify-center max-md:pt-2 md:items-center md:flex-1 md:pt-0">
          <PhoneMockup
            screenshotSrc={feature.screenshotSrc}
            screenshotAlt={feature.screenshotAlt}
          />
        </div>
      </div>
    </section>
  );
}
